export const sale_form = {
  data() {
    var validateValidDate = (rule, value, callback) => {
      if (!value || !this.data.sale_date) {
        callback();
        return;
      }
      if (value < this.data.sale_date) {
        callback(new Error("수주일보다 빠릅니다."));
      } else {
        callback();
      }
    };
    return {
      sum: 0,
      rules: {
        customer_id: [{ required: true, message: "거래처를 선택해 주세요." }],
        sale_date: [{ required: true, message: "매출일을 선택해 주세요." }],
        valid_date: [
          { required: true, message: "납기일을 선택해 주세요." },
          { validator: validateValidDate, trigger: ["blur", "change"] }
        ]
      }
    };
  },
  computed: {
    isNew: function() {
      return this.data.id < 1;
    },
    invalid_details() {
      let invalid_index = [];
      this.getDetails().forEach((d) => {
        if (d.product_name && (!d.product_id && !d.option_id)) {
          return invalid_index.push(d.seq);
        }
      });
      return invalid_index;
    },
  },
  methods: {
    initData() {
      return {
        id: 0,
        code: "",
        customer_id: 0,
        sale_date: this.util.getDate(0),
        valid_date: this.util.getDate(30),
        charge_id: null,
        customer_charger: "",
        location: "",
        customer_name: "",
        status_flag: "N",
        tel: "",
        fax: "",
        price: 0,
        cost: 0,
        owner: "",
        details: []
      };
    },
    getDetails(getPerAmount = false) {
      const trades = this.$refs.trade.result();
      const details = [];
      //let product_name = '';
      for (let i = 0; i < trades.length; i++) {
        if (!trades[i].product_id && !trades[i].amount) {
          continue;
        }
        let detail = Object.assign({}, trades[i]);
        if (!detail.cost) { detail.cost = 0 }
        if (!detail.supply_price) { detail.supply_price = 0 }
        if (!detail.tax) { detail.tax = 0 }
        if (!detail.price) { detail.price = 0 }
        if (!detail.specification || detail.specification.length < 1) { detail.specification = null }
        if (getPerAmount) {
          if (detail.specification) {
            let machine_amount = 0;
            detail.specification.forEach(s => {
              let machine_detail = details.find(d => d.seq === s);
              if (machine_detail) {
                machine_amount += Number.parseFloat(machine_detail.amount);
              }
            });
            detail.per_amount = detail.amount / machine_amount;
          } else {
            detail.per_amount = detail.amount;
          }
        }
        // detail.seq = i + 1;        
        details.push(detail);
      }      
      return details;
    },  
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.data.customer_id = null;
        this.data.customer_name = c;        
        this.customer = null;
      } else {
        this.data.customer_id = c.id;
        this.data.customer_name = c.name;        
        this.customer = c;
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    handleClickClear() {
      // this.$refs.trade.clear();
      this.data.id = 0;
      this.data.contract_date = this.util.getDate(0);
      this.data.delivery_date = this.util.getDate(30);
      this.data.details = [];
    },
  }
}